import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { REFULFILLMENT_PUSH_MAX_LOCATIONS } from "./refulfillment-inventory-push-request";

export const REFULFILLMENT_PRODUCT_SEARCH_LIMIT = 100;

const RefulfillmentToolsProduct_ = z.object({
  /** CRDB product ID; each Shopify variant is its own product. */
  productId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  /** Sellable stock across the requested enabled locations; null when none were requested. */
  availableQuantity: z.number().int().nullable(),
});
export const RefulfillmentToolsProduct: z.ZodType<RefulfillmentToolsProduct> =
  RefulfillmentToolsProduct_;
export interface RefulfillmentToolsProduct extends z.infer<
  typeof RefulfillmentToolsProduct_
> {}

/** Merchant Shopify variants matching a title or SKU search. */
export const searchRefulfillmentToolsProducts = unaryRpc({
  name: "searchRefulfillmentToolsProducts" as const,
  input: z.object({
    merchantTeamId: zExt.objectId(),
    search: z.string().trim().max(200).optional(),
    /** Only variants with sellable stock at the requested source locations. */
    inStockOnly: z.boolean().optional(),
    sourceLocationIds: z
      .array(z.string().regex(/^\d+$/))
      .max(REFULFILLMENT_PUSH_MAX_LOCATIONS)
      .optional(),
  }),
  output: z.object({
    products: z.array(RefulfillmentToolsProduct),
    /** More variants match than one response returns. */
    truncated: z.boolean(),
  }),
});
